import React, { useContext } from 'react'
import { formFieldNames } from '.'
import { FormFieldContainer, RadioButtonsContainer, StyledLabel, StyledRequired } from 'components/form-fields/shared-style'
import CustomCheckBox from 'components/form-fields/checkbox'
import { StyledHeading, StyledPageHeader, StyledParagraph, StyledProcessText } from './style'
import { useFormContext } from 'react-hook-form'
import { IProduct, ProductContext } from 'context/productsContext'
import { translate } from 'locales/i18n'

const FormStep2: React.FC = () => {
  const { webProducts, mobileProducts } = useContext(ProductContext)

  const { watch } = useFormContext()

  const watchCurrentStep = watch(formFieldNames.CURRENT_STEP)
  const watchApplicationType = watch(formFieldNames.APPLICATION_TYPE)
  const watchFeatures = watch(formFieldNames.FEATURES)

  const filteredProducts = watchApplicationType === translate('forms.step1.offerType.option2') ? webProducts : watchApplicationType === translate('forms.step1.offerType.option1') ? mobileProducts : watchApplicationType === translate('forms.step1.offerType.option3') ? merge(webProducts, mobileProducts) : []

  function merge (array1: IProduct[], array2: IProduct[]): IProduct[] {
    const arrayMerge = array1.concat(array2)
    return arrayMerge.filter((item, index) =>
      arrayMerge.indexOf(item) === index
    )
  }

  const selectedFeatures = Object.keys(watchFeatures).filter(key => watchFeatures[key])

  return (
    <div>
      <StyledPageHeader>
        <div>
          <StyledHeading>{translate('forms.step2.heading')}</StyledHeading>
        </div>
        <StyledProcessText>{translate('forms.steps', { watchCurrentStep })}</StyledProcessText>
      </StyledPageHeader>
      <StyledParagraph>{translate('forms.step2.paragraph')}</StyledParagraph>
      <FormFieldContainer>
        <StyledLabel>
             <StyledRequired>*</StyledRequired>
             {translate('forms.step2.cta', {
               option1: watchApplicationType === translate('forms.step1.offerType.option3') ? translate('misc.both') : translate('misc.the'),
               option2: watchApplicationType === translate('forms.step1.offerType.option3') ? 's' : ''
             })}
         </StyledLabel>
        <RadioButtonsContainer>
        {filteredProducts.map((item) => {
          return (
            <CustomCheckBox
                key={item.id}
                name={`${formFieldNames.FEATURES}.${item.name}`}
                label={item.name}
                value={item.id}
                isChecked={selectedFeatures.includes(item.name)}
              />
          )
        })}
        </RadioButtonsContainer>
      </FormFieldContainer>
    </div>
  )
}

export default FormStep2
